const URLS = {
  // baseUrl: 'https://store.kkoruruk-dev.com',
  baseUrl: 'https://store.kkoruruk-prod.com',

  // 전자계약 관련
  getStoreOfContract: '/api/v0/electronic-contract/store',
  postAgreementOfContract: '/api/v0/electronic-contract/agreement',
  getModusignLink: '/api/v0/ucansign/template/request',
  uploadContract: '/api/v0/ucansign/contract/upload',
  getModusignDocument: '/api/v0/ucansign/latest/store',

  /// 이용약관
  // 계약 동의 (필수)
  storeEfinanceTerms:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_contract_consent.html',

  // 서비스 이용약관 동의 (필수)
  storeTermsOfUse:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_service_terms_consent.html',

  // 리뷰승계 불가 동의 (필수)
  reviewTermsOfUse:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_review_inheritance_block_consent.html',

  // 고객 개인정보 보호 (필수)
  userPrivacyPolicy:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_customer_info_protection_consent.html',

  // 업주 개인정보 수집 및 동의 (필수)
  privacyPolicy:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_personal_info_consent_delegation.html',

  // 개인정보 취급 및 위탁 동의 (필수)
  storePrivacyPolicy:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_personal_info_consent_delegation.html',

  // 출금 동의 (필수)
  storeCashTerms:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_withdrawal_consent.html',

  // 마케팅 활용 동의 약관(선택)
  storeMarketingConsent:
    'https://gy-soft.s3.ap-northeast-2.amazonaws.com/%EC%95%BD%EA%B4%80/%EB%A7%A4%EC%9E%A5/store_marketing_consent.html',
};

export default URLS;
